import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* 공통 JS */
import * as Server from 'assets/js/Server';

const UserSelectModal = props => {
  const [search, setSearch] = useState({ workerName: '' });
  const [workerMstList, setWorkerMstList] = useState([{
    workerId: '',
    workerName: '',
    workerPhone: '',
    idx: 0,
  }]);
  const [userChecked, setUserChecked] = useState({});

  useEffect(() => {
    setUserChecked(props.item);

    getWorkerMstList();
  }, []);

  const getWorkerMstList = () => {
    Server.sendGet('workforce/worker', search, getWorkerMstListCallback).then();
  };

  const getWorkerMstListCallback = res => {
    if (res['apiCode'] === 'S001') {
      const workerList = [];

      res['resultList'].forEach(val => {
        let isWorker = false;

        props?.list.forEach(v => {
          if (val.workerId === v.workerId) {
            isWorker = true;
          }
        });

        if (!isWorker) {
          workerList.push(val);
        }
      });

      setWorkerMstList(workerList);
    }
  };

  const onEnter = event => {
    if (event.keyCode === 13) {
      event.preventDefault();

      getWorkerMstList();
    }
  };

  const checkHandled = (checkThis, item) => {
    const checkboxes = document.getElementsByName('userCheckBox');

    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checkThis) {
        checkboxes[i].checked = false;
      }
    }

    if (checkThis.checked) {
      setUserChecked({ ...userChecked, ...item });
    } else {
      setUserChecked({});
    }
  };

  const onChoice = () => {
    props.choice(userChecked);
  };

  return (
    <>
      <UserModalWrap>
        <ModalUser>
          <Title>
            <TitHead>
              <i/>
              <h4>Workers Search</h4>
            </TitHead>
            <button onClick={() => props.close()}>
              <img
                src='https://mendle-s3-bucket.s3.ap-northeast-2.amazonaws.com/beauty-book/bb/common/close_ic.svg'
                alt='닫기'
              />
            </button>
          </Title>
          <MsUtil>
            <UtilRight>
              <SearchInput
                type='text'
                name='workerName'
                id='workerName'
                placeholder='Name'
                onKeyDown={e => {
                  onEnter(e);
                }}
                onChange={e => {
                  setSearch(() => {
                    return {
                      ...search,
                      workerName: e.target.value,
                    }
                  });
                }}
              />
              <SearchBtn type='button' onClick={getWorkerMstList}>Search</SearchBtn>
              <SearchBtn type='button' onClick={onChoice}>Choice</SearchBtn>
            </UtilRight>
          </MsUtil>

          <MsTable>
            <form>
              <table>
                <colgroup>
                  <col width='10%'/>
                  <col width='30%'/>
                  <col width='30%'/>
                  <col width='30%'/>
                </colgroup>
                <thead>
                <tr>
                  <th>Choice</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                </tr>
                </thead>
                <tbody>
                {workerMstList.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <SelectChkLabel>
                        <SelectChk
                          type='checkbox'
                          checked={userChecked?.workerId === item.workerId || false}
                          onChange={e => checkHandled(e.target, item)}
                        />
                      </SelectChkLabel>
                    </td>
                    <td>{item.workerId}</td>
                    <td>{item.workerName}</td>
                    <td>{item.workerPhone}</td>
                  </tr>
                ))}
                </tbody>
              </table>
            </form>
          </MsTable>
        </ModalUser>

        <Dimmed/>
      </UserModalWrap>
    </>
  );
};

// 스타일 컴포넌트
const UserModalWrap = styled.div`
  z-index: 999;
  width: 100vw;
  height: 100vh;
`;

const ModalUser = styled.div`
  z-index: 22;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  padding: 16px;
  background: #ffffff;
  border-radius: 12px;
  height: 50vh;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }

  & button {
    overflow: visible;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    background: transparent;
    border-radius: 0;
  }
`;

const MsUtil = styled.div`
  margin-top: 30px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UtilRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0 7px;
`;

const SearchInput = styled.input`
  height: 35px;
  line-height: 35px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #d0d0d0;
  outline: none;

  &:focus {
    outline: 1px solid #045488;
  }
`;

const SearchBtn = styled.button`
  width: 100px;
  height: 35px;
  line-height: 35px;
  border-radius: 8px;
  background: #045488;
  border: #045488;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
`;

const MsTable = styled.div`
  margin-top: 35px;
  position: relative;
  overflow-y: scroll;
  height: calc(100% - 165px);

  &::-webkit-scrollbar {
    display: none;
  }

  & table {
    width: 100%;
    border-collapse: collapse;

    & thead {
      position: sticky;
      top: 0;
      background: white;
    }

    & th {
      padding: 16px 0;
      font-weight: 700;
      font-size: 14px;
      color: #045488;
    }

    & td {
      padding: 16px 0;
      font-weight: 500;
      font-size: 14px;
      color: #1c1c1c;
      text-align: center;
      border-top: 1px solid #e1e1e3;
    }
  }
`;

const SelectChk = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  background: url(https://mendle-s3-bucket.s3.ap-northeast-2.amazonaws.com/beauty-book/bb/admin/admin_chkOff.svg) 50% 50% no-repeat;
  background-size: 24px 24px;

  &:checked {
    background: url(https://mendle-s3-bucket.s3.ap-northeast-2.amazonaws.com/beauty-book/bb/admin/admin_chkOn.svg) 50% 50% no-repeat;
  }
`;

const SelectChkLabel = styled.label``;

const Dimmed = styled.div`
  z-index: 11;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
`;

export default UserSelectModal;